export { AutoSaveIndicator } from './AutoSaveIndicator';
export type { AutoSaveIndicatorProps } from './AutoSaveIndicator';
